export const chartData = ({
  feudBattles,
  factionHelpSent,
  factionMissions,
  factionTokenSpent,
}) => {
  return [
    {
      title: 'total_feud_battles',
      firstIcon: 'chart-empty',
      firstIconTitle: feudBattles[feudBattles.length - 1],
      secondIcon: 'chart-fill',
      secondIconTitle: feudBattles.reduce((acc, cur) => acc + cur, 0),
      gradientZero: 'rgba(0, 160, 255, 0.2)',
      data: feudBattles,
      borderColor: '#00a0ff',
      id: 1,
    },
    {
      title: 'total_expeditions',
      firstIcon: 'compass-empty',
      firstIconTitle: factionMissions[factionMissions.length - 1],
      secondIcon: 'compass-fill',
      secondIconTitle: factionMissions.reduce((acc, cur) => acc + cur, 0),
      gradientZero: 'rgba(227, 152, 8, 0.3)',
      data: factionMissions,
      borderColor: '#FFA800',
      id: 2,
    },
    {
      title: 'total_faction_heals',
      firstIcon: 'shield-cross-empty',
      firstIconTitle: factionTokenSpent[factionTokenSpent.length - 1],
      secondIcon: 'shild',
      secondIconTitle: factionTokenSpent.reduce((acc, cur) => acc + cur, 0),
      gradientZero: 'rgba(125, 11, 232, 0.3)',
      data: factionTokenSpent,
      borderColor: '#8C30E2',
      id: 3,
    },
    {
      title: 'total_faction_helps',
      firstIcon: 'message-empty',
      firstIconTitle: factionHelpSent[factionHelpSent.length - 1],
      secondIcon: 'message-fill',
      secondIconTitle: factionHelpSent.reduce((acc, cur) => acc + cur, 0),
      gradientZero: 'rgba(18, 238, 177, 0.3)',
      data: factionHelpSent,
      borderColor: '#12EEB1',
      id: 4,
    },
  ];
};
